import axios from 'axios'
import { i18n } from '@/main.js' 

export default({
    state: {
        user: null,
        users: [],

        createUserDialog: false,
        editPasswordDialog: false,

        // Editing values of user:
        editing: false,
        newName: "",
        newSurname1: "",
        newSurname2: "",
        newEmail: "",
        currentPassword: "",
        newPassword: "",
        repeatedPassword: "",
    },

    getters: {
        getUser(state){ return state.user },
        getUsers(state){ return state.users },

        getCreateUserDialog(state){ return state.createUserDialog },
        getEditPasswordDialog(state){ return state.editPasswordDialog },

        isEditingUser(state){ return state.editing },
        getUserName(state){ return state.newName },
        getUserSurname1(state){ return state.newSurname1 },
        getUserSurname2(state){ return state.newSurname2 },
        getUserEmail(state){ return state.newEmail },
        getUserCurrentPassword(state){ return state.currentPassword },
        getUserNewPassword(state){ return state.newPassword },
        getUserRepeatedPassword(state){ return state.repeatedPassword },
    },

    mutations: {
        setUser(state, value){ state.user = value },
        setUsers(state, value){ state.users = value },

        setCreateUserDialog(state, value){ state.createUserDialog = value },
        setEditPasswordDialog(state, value){ state.editPasswordDialog = value },

        setEditingUser(state, value){ state.editing = value },
        setUserName(state, value){ state.newName = value },
        setUserSurname1(state, value){ state.newSurname1 = value },
        setUserSurname2(state, value){ state.newSurname2 = value },
        setUserEmail(state, value){ state.newEmail = value },
        setUserCurrentPassword(state, value){ state.currentPassword = value },
        setUserNewPassword(state, value){ state.newPassword = value },
        setUserRepeatedPassword(state, value){ state.repeatedPassword = value },

        // Set editing user values to current user values. Used when editing a user
        resetUserValues(state) {
            state.newName = state.user.name
            state.newSurname1 = state.user.surname1
            state.newSurname2 = state.user.surname2
            state.newEmail = state.user.email

            state.currentPassword = ""
            state.newPassword = ""
            state.repeatedPassword = ""
        },

        newUser(state){
            state.user = {
                name: "",
                surname1: "",
                surname2: "",
                email: "",
                newPassword: "",
            }
        },
    },

    actions: {
        getUser({ commit }, userId){
            commit('setLoading')
            return new Promise((resolve) => {
                axios.get('/users/' + userId)
                .then((response) =>{
                    commit('setUser', response.data)
                    resolve()
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        getUsers({ commit }){
            commit('setLoading')
            return new Promise((resolve) => {
                axios.get('/users')
                .then((response) =>{
                    commit('setUsers', response.data)
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        createUser({ state, commit, dispatch }){
            commit('setLoading')
            return new Promise(() => {
                axios.post('/users', state.user)
                .then((response) => {
                    commit('setCreateUserDialog', false)
                    commit('setSnackBar', {value: true, text: i18n.t('userCreated'), color: 'green'})
                    dispatch('getUsers')
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        updateUser({ state, commit, dispatch }){
            commit('setLoading')

            var newUser = {...state.user}

            newUser.name = state.newName
            newUser.surname1 = state.newSurname1
            newUser.surname2 = state.newSurname2
            newUser.email = state.newEmail
            newUser.currentPassword = state.currentPassword
            newUser.newPassword = state.newPassword

            return new Promise(() => {
                axios.put('/users', newUser)
                .then(() => {
                    state.editing = false
                    commit('setEditPasswordDialog', false)
                    commit('setSnackBar', {value: true, text: i18n.t('userUpdated'), color: 'green'})
                    dispatch('getUser', state.user.id)
                    .then(() => {
                        commit('resetUserValues')
                    })
                })
                .catch((error) => {
                    if(error.response.status == 401) //Bad password
                        commit('setSnackBar', {value: true, text: i18n.t('wrongPass'), color: 'red'})
                })
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },
    },
});
